import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icon/note_icon2.svg'
import _imports_1 from '@/assets/images/close_btn.png'
import _imports_2 from '@/assets/icon/PTBID_icon.svg'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-body" }
const _hoisted_3 = { class: "content_header" }
const _hoisted_4 = { class: "content_header_left" }
const _hoisted_5 = {
  key: 2,
  class: "new_mark"
}
const _hoisted_6 = { class: "content_date" }
const _hoisted_7 = { class: "content_time" }
const _hoisted_8 = { class: "content_body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "popup-footer" }
const _hoisted_11 = { class: "footer_info_box" }
const _hoisted_12 = { class: "text_count_box" }
const _hoisted_13 = ["disabled"]

import { ref, onMounted, nextTick } from "vue";
import announceAPI from "../../api/announceAPI";
import { useRouter } from "vue-router";
import { ApiResponse, Announce, Memo } from "../../common/types";
// 부모로부터 closePopup 이벤트를 수신

export default /*@__PURE__*/_defineComponent({
  __name: 'NotePop',
  props: {
    announceData: {}
  },
  emits: ["closeNotepop", "getDetail"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

// 닫기 버튼 핸들러
const closePop = () => {
  emits("closeNotepop");
  emits("getDetail");
};
// 팝업 위치 및 드래그 상태 관리
const popupRef = ref<HTMLDivElement | null>(null);
const offset = ref({ x: 0, y: 0 });
const isDragging = ref(false);
const router = useRouter();
// 드래그 시작
const startDrag = (event: MouseEvent) => {
  if (!popupRef.value) return;

  isDragging.value = true;
  const rect = popupRef.value.getBoundingClientRect();

  // 클릭 위치와 팝업 위치 간의 거리 계산
  offset.value.x = event.clientX - rect.left;
  offset.value.y = event.clientY - rect.top;

  // 마우스 이동 및 릴리스 이벤트 등록
  document.addEventListener("mousemove", drag);
  document.addEventListener("mouseup", stopDrag);
};

// 드래그
const drag = (event: MouseEvent) => {
  if (!isDragging.value || !popupRef.value) return;

  const x = event.clientX - offset.value.x;
  const y = event.clientY - offset.value.y;

  // 팝업 위치 변경
  popupRef.value.style.left = `${x}px`;
  popupRef.value.style.top = `${y}px`;
};

// 드래그 종료
const stopDrag = () => {
  isDragging.value = false;
  document.removeEventListener("mousemove", drag);
  document.removeEventListener("mouseup", stopDrag);
};
// 상태 변수 선언
const text = ref(""); // textarea의 값
const charCount = ref(0); // 현재 글자 수
// 글자 수 업데이트 함수
const updateCharacterCount = (event: Event) => {
  // 이벤트 객체로 글자 길이를 계산
  const target = event.target as HTMLTextAreaElement;
  charCount.value = target.value.length;
};

// 메모 추가 API 호출
const addMemo = async () => {
  if (!text.value.trim()) return;
  // 사용자 확인을 위한 confirm 메시지
  const confirmed = confirm("작성한 메모를 등록하시겠습니까?");
  if (!confirmed) return;

  const payload = {
    공고순번: Number(router.currentRoute.value.params.seq),
    내용: text.value,
  };

  try {
    const res = await announceAPI.addMemo(payload);
    if (res.data.success) {
      memoDatas.value = res.data.data;
      text.value = "";
      charCount.value = 0;
      await nextTick();
      scrollToBottom();
    } else {
      alert("메모 추가에 실패했습니다.");
    }
  } catch (error) {
    console.error(error);
    alert("메모 추가 중 오류가 발생했습니다.");
  }
};

//메모 개별조회
const memoDatas = ref<Memo[]>([]);
const contentsBodyRef = ref<HTMLDivElement | null>(null);
const scrollToBottom = () => {
  if (contentsBodyRef.value) {
    setTimeout(() => {
      contentsBodyRef.value!.scrollTop = contentsBodyRef.value!.scrollHeight;
    }, 10); // DOM 업데이트 이후 실행
  }
};
const isUnreadMemo = (memo: Memo) => {
  const isContractor = true; // 역할을 확인하는 실제 로직으로 교체
  if (isContractor) {
    return memo?.수주회원확인여부 === false;
  } else {
    return memo?.수행회원확인여부 === false;
  }
};
const formatContent = (content: string | undefined): string => {
  if (!content) return ""; // null/undefined 방지
  return content.replace(/\n/g, "<br>");
};
// 메모 데이터를 조회하고 스크롤 제어
const noteDetail = async () => {
  const seq = Number(router.currentRoute.value.params.seq);

  try {
    const res = await announceAPI.memoDetail(seq);
    if (res.data.data) {
      memoDatas.value = res.data.data;

      // DOM 업데이트 후 스크롤을 제일 아래로 이동
      await nextTick();
      scrollToBottom();
    }
  } catch (error) {
    console.error("메모 데이터를 가져오는 중 오류 발생:", error);
  }
};
const announceData = ref({} as Announce);
const props = __props;

// 팝업 닫기 전에 확인
const confirmClosePop = () => {
  if (text.value.trim()) {
    const confirmed = confirm("작성 중인 메모가 있습니다. 정말 닫으시겠습니까?");
    if (!confirmed) {
      return; // 사용자가 취소하면 닫지 않음
    }
  }
  closePop(); // 작성 중이 아니거나 사용자가 확인하면 팝업 닫기
};
onMounted(() => {
  announceData.value = JSON.parse(JSON.stringify(props.announceData));
  noteDetail();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "popup_cover",
      onClick: _withModifiers(confirmClosePop, ["self"])
    }),
    _createElementVNode("div", {
      class: "file-upload-popup",
      ref_key: "popupRef",
      ref: popupRef
    }, [
      _createElementVNode("div", {
        class: "popup-header",
        onMousedown: startDrag
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header_icon_box" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "note_icon"
          }),
          _createElementVNode("div", { class: "popup_title" }, "관리자 공고 메모")
        ], -1)),
        _createElementVNode("img", {
          src: _imports_1,
          onClick: closePop,
          class: "close_icon"
        })
      ], 32),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "contents_body",
          ref_key: "contentsBodyRef",
          ref: contentsBodyRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoDatas.value, (memo, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contents_box",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (memo.회원 == null)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_2,
                        class: _normalizeClass(["content_icon", { 'with-new': isUnreadMemo(memo) }])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  (memo.회원 != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["content_icon", { 'with-new': isUnreadMemo(memo) }])
                      }, _toDisplayString(memo?.회원?.사업자명), 3))
                    : _createCommentVNode("", true),
                  (isUnreadMemo(memo))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "NEW"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(memo?.작성일시날짜), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "content_line" }, null, -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(memo?.작성일시시간), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "content_text",
                  innerHTML: formatContent(memo?.내용)
                }, null, 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("textarea", {
          class: "text_box",
          placeholder: "내용을 입력하세요.",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
          onInput: updateCharacterCount,
          maxlength: "200",
          name: "",
          id: ""
        }, null, 544), [
          [_vModelText, text.value]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, _toDisplayString(charCount.value), 1),
            _cache[3] || (_cache[3] = _createElementVNode("div", null, "/", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("div", null, "200", -1))
          ]),
          _createElementVNode("div", {
            class: "text_button",
            disabled: charCount.value === 0,
            onClick: addMemo
          }, "작성", 8, _hoisted_13)
        ])
      ])
    ], 512)
  ]))
}
}

})